const PATHS = {
  plan: '<rect x="3" y="4" width="18" height="16" rx="1.5"/><path d="M3 10h8v10M11 14h10"/>',
  cube: '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/>',
  cart: '<path d="M3 15h14V7H3z"/><path d="M17 11h2l2 4h-4"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="16" cy="18" r="1.8"/>',
  users: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5"/><path d="M16 4.6a3.5 3.5 0 010 6.8M18 14.8c1.8.7 3 2.4 3.5 5.2"/>',
  building: '<path d="M4 21V5l8-2v18M12 8l8 2v11M3 21h18M7 9h2M7 13h2M7 17h2M15 13h2M15 17h2"/>',
  plug: '<path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 01-12 0zM12 17v4"/>',
  chart: '<path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/>',
  alert: '<path d="M12 3l9.5 17h-19z"/><path d="M12 10v4M12 17v.5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  pointer: '<path d="M5 3l14 7-6 2-2 6z"/>',
  ruler: '<path d="M3 17L17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/>',
  rect: '<rect x="4" y="6" width="16" height="12" rx="1"/>',
  poly: '<path d="M5 19l2-12 7-3 5 8-6 7z"/>',
  zone: '<rect x="4" y="5" width="16" height="14" rx="1.5" stroke-dasharray="3 2.4"/>',
  zonePoly: '<path d="M5 19l2-12 7-3 5 8-6 7z" stroke-dasharray="3 2.4"/>',
  wall: '<path d="M4 18L20 6" stroke-width="3.2"/>',
  anchor: '<path d="M12 4l7 4-7 4-7-4z"/><path d="M8 15c2.2 2 5.8 2 8 0M5.5 18c3.6 3 9.4 3 13 0"/>',
  trash: '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/>',
  back: '<path d="M15 5l-7 7 7 7"/>',
  save: '<path d="M5 4h11l3 3v13H5z"/><path d="M8 4v5h7V4M8 20v-6h8v6"/>',
  undo: '<path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 010 11H11"/>',
  home: '<path d="M4 11l8-6 8 6v8h-5v-5H9v5H4z"/>',
  top: '<rect x="4" y="4" width="16" height="16" rx="1"/><path d="M4 10h16M10 10v10"/>',
  play: '<path d="M7 5l12 7-12 7z"/>',
  pause: '<path d="M8 5v14M16 5v14"/>',
  upload: '<path d="M12 16V4M7 9l5-5 5 5M4 20h16"/>',
  download: '<path d="M12 4v12M7 11l5 5 5-5M4 20h16"/>',
  close: '<path d="M6 6l12 12M18 6L6 18"/>',
  key: '<circle cx="8" cy="15" r="4"/><path d="M11 12l9-9M17 6l3 3M15 8l2 2"/>',
  logout: '<path d="M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10"/>',
  route: '<circle cx="6" cy="18" r="2"/><circle cx="18" cy="6" r="2"/><path d="M8 18h6a3 3 0 000-6h-4a3 3 0 010-6h6"/>',
  edit: '<path d="M4 20h4L19 9l-4-4L4 16z"/>',
  eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  search: '<circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4-4"/>',
  history: '<path d="M3 12a9 9 0 103-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/>',
  docs: '<path d="M6 3h9l4 4v14H6z"/><path d="M15 3v4h4M9 12h7M9 16h7"/>',
  magic: '<path d="M4 20L15 9M13 7l2-2 4 4-2 2z"/><path d="M6 3v4M4 5h4M19 14v4M17 16h4"/>',
  copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 00-1-1H5a1 1 0 00-1 1v10a1 1 0 001 1h3"/>',
  dashboard: '<rect x="3" y="3" width="7.5" height="9" rx="1.5"/><rect x="13.5" y="3" width="7.5" height="5" rx="1.5"/><rect x="13.5" y="11" width="7.5" height="10" rx="1.5"/><rect x="3" y="15" width="7.5" height="6" rx="1.5"/>',
  battery: '<rect x="3" y="7" width="16" height="10" rx="2"/><path d="M21 10.5v3M6.5 10v4"/>',
  globe: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.8 3 2.8 15 0 18M12 3c-2.8 3-2.8 15 0 18"/>',
  shelf: '<rect x="3" y="6" width="18" height="10" rx="1.5"/><rect x="5.5" y="8.5" width="9" height="5" rx=".5"/><circle cx="17.5" cy="11" r="1"/><path d="M8 19h8"/>',
  pick: '<path d="M9 5h10M9 12h10M9 19h10"/><path d="M3.5 5l1.5 1.5L7.5 4M3.5 12l1.5 1.5L7.5 11"/><circle cx="5" cy="19" r="1.3"/>',
  wrench: '<path d="M14.5 6.5a4 4 0 00-5.3 5.3L4 17l3 3 5.2-5.2a4 4 0 005.3-5.3l-2.5 2.5-2.5-.5-.5-2.5z"/>',
  minus: '<path d="M5 12h14"/>',
  zoomIn: '<circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4-4M8 11h6M11 8v6"/>',
  zoomOut: '<circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4-4M8 11h6"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  qr: '<rect x="4" y="4" width="6" height="6" rx="1"/><rect x="14" y="4" width="6" height="6" rx="1"/><rect x="4" y="14" width="6" height="6" rx="1"/><path d="M14 14h2v2h-2zM18 14h2M14 18h2M18 18h2v2M18 16v2"/>',
  scan: '<path d="M4 8V5a1 1 0 011-1h3M16 4h3a1 1 0 011 1v3M20 16v3a1 1 0 01-1 1h-3M8 20H5a1 1 0 01-1-1v-3M4 12h16"/>',
  link: '<path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1"/>',
  unlink: '<path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1M4 4l16 16"/>',
  print: '<path d="M7 9V4h10v5M7 17H5a1 1 0 01-1-1v-6a1 1 0 011-1h14a1 1 0 011 1v6a1 1 0 01-1 1h-2"/><path d="M7 14h10v6H7z"/>',
  rfid: '<rect x="7" y="9" width="10" height="10" rx="1.5"/><path d="M10 13h4M9 6.5a5 5 0 016 0M6.5 4a9 9 0 0111 0"/>',
  box: '<path d="M4 8l8-4 8 4v9l-8 4-8-4z"/><path d="M4 8l8 4 8-4M12 12v9M8 6l8 4"/>',
  pallet: '<rect x="5" y="5" width="14" height="9" rx="1"/><path d="M3 17h18M3 20h18M6 17v3M12 17v3M18 17v3"/>',
  palletJack: '<path d="M3 17h13M3 17v-2h11M14 15V5M14 5h3"/><circle cx="5" cy="19" r="1.5"/><circle cx="12" cy="19" r="1.5"/><circle cx="17.5" cy="18" r="2.5"/>',
  toolbox: '<rect x="3" y="8" width="18" height="11" rx="1.5"/><path d="M9 8V5h6v3M3 13h18M10 13v2h4v-2"/>',
  container: '<rect x="3" y="6" width="18" height="12" rx="1"/><path d="M7 6v12M11 6v12M15 6v12M19 6v12"/>',
  truck: '<path d="M3 16V7h11v9M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
  tank: '<path d="M7 4h10v13a5 3 0 01-10 0z"/><path d="M7 8h10M9 21l-1 1M15 21l1 1"/>',
  pump: '<circle cx="10" cy="12" r="5"/><path d="M10 12l3-2M15 12h5M20 9v6M5 19h10"/>',
  gauge: '<path d="M4 16a8 8 0 1116 0"/><path d="M12 16l4-5M4 20h16"/>',
  cooler: '<rect x="4" y="7" width="16" height="12" rx="1.5"/><path d="M4 11h16M9 4h6v3M12 13v4M10 15h4"/>',
  mop: '<path d="M14 3l-4 11M7 14h6l1 7H6z"/><path d="M8 18v3M11 18v3"/>',
  medical: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M12 8v8M8 12h8"/>',
  cart2: '<path d="M3 5h3l2 10h10l2-7H7"/><circle cx="9" cy="19" r="1.5"/><circle cx="17" cy="19" r="1.5"/>',
  tag: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/>',
  phone: '<rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M11 18h2"/>',
  check: '<path d="M5 12l4 4 10-10"/>',
  eyeOff: '<path d="M3 3l18 18M10.6 6.1A10 10 0 0112 6c6.4 0 10 6 10 6a17 17 0 01-3.2 3.8M6.2 7.6C3.6 9.3 2 12 2 12s3.6 6 10 6c1.5 0 2.9-.3 4.1-.8"/><path d="M9.9 9.9a3 3 0 004.2 4.2"/>',
  drag: '<circle cx="9" cy="6" r="1"/><circle cx="15" cy="6" r="1"/><circle cx="9" cy="12" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="9" cy="18" r="1"/><circle cx="15" cy="18" r="1"/>',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 18, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}
      dangerouslySetInnerHTML={{ __html: PATHS[name] }}
    />
  );
}

/** SVG markup of an icon, for DOM built outside React (3D pins) or drawn on a canvas. */
export function iconSvg(name: IconName, size = 14, color = 'currentColor', strokeWidth = 2): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${PATHS[name]}</svg>`;
}

/** The icon as an image, ready for `drawImage` on a canvas (cached). */
const iconImages = new Map<string, HTMLImageElement>();
export function iconImage(name: IconName, color: string, onReady?: () => void): HTMLImageElement {
  const key = `${name}|${color}`;
  let image = iconImages.get(key);
  if (!image) {
    image = new Image();
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(iconSvg(name, 48, color, 2.2))}`;
    iconImages.set(key, image);
  }
  if (!image.complete && onReady) image.addEventListener('load', onReady, { once: true });
  return image;
}

export function Logo({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#6B7445" />
      <path d="M7 24 L16 8 L25 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinejoin="round" opacity=".55" />
      <path d="M10.5 24 A7 7 0 0 1 16 17.2" fill="none" stroke="#F2B705" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="16" cy="8" r="2.6" fill="#F2B705" />
    </svg>
  );
}
